import { css } from 'lit';

var css_248z = css`:host{width:100%}:host .progress-bar{font-size:var(--sgds-progress-font-size);height:100%}:host .progress-bar[class*=bg-light]{color:var(--sgds-dark)}:host .progress-bar[class*=bg-dark]{color:var(--sgds-light)}`;

export { css_248z as default };
//# sourceMappingURL=sgds-progress-bar2.js.map
